export default "__VITE_ASSET__CMAY3i91__"